import { ConfigProvider } from "antd";
import "antd/dist/reset.css";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { primaryColor, ProjectName, secondaryColor } from "./config";
import { persistor, store } from "./redux/store";
import Routers from "./routers";
import GlobalStyles from "./styles/GlobalStyles";





function App() {
  document.title = ProjectName;
  const handleLoad = () => {
    console.log("Page fully loaded including stylesheets, images, etc.");
  };

  useEffect(() => {
    window.addEventListener("load", handleLoad);
    return () => {};
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider
          theme={{
            token: {
              fontFamily: `"Inter", sans-serif`,
            },
            components: {
              Checkbox: {
                colorPrimary: '#F45B68',
                colorPrimaryHover: '#cd404c',
                colorPrimaryActive: '#F45B68',
                borderRadius: 4,
                controlHeight: 20,
                size: 16,
                borderColor: "#ddd", // Custom border color for unchecked state
                colorBgContainer: "#fff", // Background
                colorText: "#333",
                colorTextDisabled: "#bdbdbd",
                colorBorder: "#ddd"
              },
              Switch: {
                colorPrimary: '#F45B68',
                colorPrimaryHover: '#cd404c',
                colorPrimaryActive: '#F45B68',
                handleBg: "#fff",
                trackHeight: 26,
                trackMinWidth: 38,
                handleSize: 18,
                borderRadius: 22,
                // Optionally: customize disabled/off states
                colorText: "#333",
                colorTextTertiary: "#bdbdbd",
                colorBorder: "#ddd"
              }
            }
          }}
        >
          <GlobalStyles />
          <Routers />
        </ConfigProvider>
      </PersistGate>
      
    </Provider>
  );
}

export default App;
